export interface Cadastro {
  avaliacao: string;
  cidades: string[];
  curriculo: string;
  curtida: number;
  endereco: string;
  especialidade: string;
  facebook: string;
  email: string;
  celular: string;
  whatsap: string;
  latitude: string;
  longitude: string;
  nome: string;
  telefone: string;
  tipo: string;
  urlImage: string;
  key: string;
  site: string;
  urlVideo: string;
}

export interface CadastroSimples {
  texto: string;
  link: string;
  noticia: string;
  descricao: string;
  ativo: boolean;
  tipo: string;
  urlImage: string;
  key: string;
}

export interface Agenda {
  ativo: boolean;
  data: string;
  descricao: string;
  link: string;
  texto: string;
  tipo: string;
  urlImage: string;
  key: string;
}

export enum Especialidades {
  PERSONAL = "Personal",
  ORTOPEDISTA = "Ortopedista",
  NUTRICIONISTA = "Nutricionista",
  MEDICINA_ESPOTIVA = "Medicina Esportista",
  TRATAMENTO_ALTERNATIVO = "Tratamento Alternativo",
  PSICOLOGO = "Psicologo",
  FISIOTERAPIA = "Fisioterapia",
  SUPLEMENTOS = "Suplementos",
  ALIMENTACAO_NATURAL = "Alimentação Natural",
  SUCOS = "Sucos",
  LANCHONETES = "Lanchonetes",
  CARDIOLOGISTA = "Cardiologista",
  RESTAURANTES = "Restaurantes",
}

export enum Tipos {
  LOJAS = "Lojas",
  ESPECIALISTAS = "Especialistas",
  PROMOCAO = "Promoção",
}

export enum TipoInformacao {
  VITAMINAS_MINERAIS = "Tipos de Vitaminas e minerais",
  MASSA = "+ Massa",
  MAGRO = "+ Magro",
  SUPLEMENTOS = "O que são suplementos",
  NUTRIENTES = "Nutrientes",
  VITAMINAS = "O que são Vitaminas",
  WHEY = "Whey Proteínas",
  INFO = "Informações",
  BANNER = "Banner",
  PROMOCAO = "Promoção",
  ANABOLIZANTES = "Anabolizantes",
  OUTROS = "Outros",
}

export enum repositorio {
  CADASTRO = "Cadastros",
  CADASTRO_SIMPLES = "CadastrosSimples",
  AGENDA = "Agenda",
}

export enum TipoEvento {
  FEIRA = "Feira",
  CURSO = "Curso",
  EVENTO = "Evento",
  FERIADO = "Feriado",
  ANIVERSARIO = "Aniversario",
  OUTROS = "Outros",
}
